export const ADD_SHARE_EMAIL = 'ADD_SHARE_EMAIL';
export const REMOVE_SHARE_EMAIL = 'REMOVE_SHARE_EMAIL';
export const SHARE_VIA_EMAIL_SUCCESS = 'SHARE_VIA_EMAIL_SUCCESS';
export const SHARE_VIA_EMAIL_ERROR = 'SHARE_VIA_EMAIL_ERROR';
export const SHARE_SEGMENT_TITLE = 'Share This Segment';
export const CLEAN_SHARE_STATE = 'CLEAN_SHARE_STATE';
export const GET_SEGMENT_SHARE = 'GET_SEGMENT_SHARE';
export const POST_SEGMENT_SHARE = 'POST_SEGMENT_SHARE';
